import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
  filled?: boolean;
}

/** Custom organic heart — softer curves, thicker stroke than Lucide */
export function IconHeart({ className, filled }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      <path d="M12 21.35C12 21.35 3 15.2 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.72 3.94 12 4.34C12.28 3.94 13.76 3 15.5 3C18.58 3 21 5.42 21 8.5C21 15.2 12 21.35 12 21.35Z" />
    </svg>
  );
}
